/* eslint-disable @typescript-eslint/no-unused-vars */
import Flickity from 'flickity';
require('flickity-imagesloaded');

const PageCarousel = () => {
  const sliders = document.querySelectorAll(
    '[data-page-carousel="carousel"]',
  );

  const options = {
    freeScroll: true,
    prevNextButtons: true,
    pageDots: false,
    contain: false,
    lazyLoad: 6,
    groupCells: 1,
    imagesLoaded: true,
  };

  const mediaMd = getComputedStyle(document.documentElement).getPropertyValue(
    '--breakpoint-md',
  );
  const mediaXl = getComputedStyle(document.documentElement).getPropertyValue(
    '--breakpoint-xl',
  );

  if (matchMedia(`screen and (min-width: ${mediaMd})`).matches) {
    options.groupCells = 2;
  }
  if (matchMedia(`screen and (min-width: ${mediaXl})`).matches) {
    options.groupCells = 3;
  }

  sliders.forEach((slide) => {
    // eslint-disable-next-line no-new
    new Flickity(slide, options);
  });
};
export default PageCarousel;
